import { render, staticRenderFns } from "./noticeManagement.vue?vue&type=template&id=27b4e8c3&"
import script from "./noticeManagement.vue?vue&type=script&lang=js&"
export * from "./noticeManagement.vue?vue&type=script&lang=js&"
import style0 from "./noticeManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports